/* Breakpoint Tees — product detail page (Shopify) */
(function () {
  'use strict';

  /* ---------- Money formatting (Shopify style) ---------- */
  var moneyFormat = window.__moneyFormat || '${{amount}}';
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var n2 = (cents / 100).toFixed(precision);
      var parts = n2.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cent = parts[1] ? decimal + parts[1] : '';
      return dollars + cent;
    }
    var match = moneyFormat.match(placeholder);
    var name = match ? match[1] : 'amount';
    var value;
    switch (name) {
      case 'amount_no_decimals': value = num(0); break;
      case 'amount_with_comma_separator': value = num(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(0, '.', ','); break;
      default: value = num(2);
    }
    return moneyFormat.replace(placeholder, value);
  }

  // "$34.00" -> "$34" (mirrors Liquid's money_without_trailing_zeros)
  function formatMoneyShort(cents) {
    return formatMoney(cents).replace(/([0-9])[.,]00(?![0-9])/, '$1');
  }

  /* ---------- Gallery ---------- */
  var thumbs = document.querySelectorAll('.pd-thumb');
  var mainImg = document.getElementById('pdMainImg');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      var full = thumb.getAttribute('data-full');
      var img = thumb.querySelector('img');
      if (mainImg) mainImg.src = full || (img ? img.src : mainImg.src);
    });
  });

  /* ---------- Variant picker ---------- */
  var form = document.getElementById('product-form');
  var variants = [];
  var dataEl = document.getElementById('ProductVariantsData');
  if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; } }

  var idInput = document.getElementById('pdVariantId');
  var qtyInput = document.getElementById('pdQuantity');
  var addBtn = document.getElementById('pdAddBtn');
  var priceBox = document.getElementById('pdPrice');
  var colorLabel = document.getElementById('pdColorLabel');

  var sizePos = form ? parseInt(form.getAttribute('data-size-position'), 10) : NaN;
  var colorPos = form ? parseInt(form.getAttribute('data-color-position'), 10) : NaN;
  var sectionId = form ? form.getAttribute('data-section-id') : null;
  var productUrl = form ? form.getAttribute('data-product-url') : null;
  var productHandle = form ? form.getAttribute('data-product-handle') : null;

  var selected = { size: null, color: null };

  var activeSwatch = document.querySelector('.pd-swatches .sw--active');
  if (activeSwatch) selected.color = activeSwatch.getAttribute('data-value');

  /* ---------- Bundle tiers ---------- */
  var packRow = document.getElementById('pdPackRow');
  var qtyLabel = document.getElementById('pdQtyLabel');
  var packProp = document.getElementById('pdPackProp');
  var returnTo = document.getElementById('pdReturnTo');
  var roundSavings = packRow ? packRow.getAttribute('data-round-savings') === 'true' : true;
  var activePack = packRow ? packRow.querySelector('.pack--active') : null;

  // The variant the price/tier maths is currently based on.
  var currentVariant = null;
  if (idInput) {
    currentVariant = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || null;
  }
  if (!currentVariant) currentVariant = variants[0] || null;

  function tierOf(el) {
    if (!el) return { qty: 1, discount: 0, label: '', subtext: '', code: '' };
    return {
      qty: parseInt(el.getAttribute('data-qty'), 10) || 1,
      discount: parseFloat(el.getAttribute('data-discount')) || 0,
      label: el.getAttribute('data-label') || '',
      subtext: el.getAttribute('data-subtext') || '',
      code: el.getAttribute('data-code') || ''
    };
  }

  // Strikethrough unit price vs the unit price actually charged.
  function unitPrices(v) {
    var price = v ? v.price : 0;
    var full = v && v.compare_at_price && v.compare_at_price > price ? v.compare_at_price : price;
    return { price: price, full: full };
  }

  // Math.floor everywhere so JS matches Liquid's integer `divided_by`.
  function tierTotals(t, u) {
    var now = Math.floor(u.price * t.qty * (100 - t.discount) / 100);
    var full = u.full * t.qty;
    var save = full - now;
    if (roundSavings) save = Math.floor(save / 100) * 100;
    return { now: now, full: full, save: save, item: Math.floor(now / t.qty) };
  }

  // Recalculate every tier's "Save $X" against the current variant price.
  function renderPacks(v) {
    if (!packRow) return;
    var u = unitPrices(v);
    packRow.querySelectorAll('.pack').forEach(function (el) {
      var out = el.querySelector('[data-pack-save]');
      if (!out) return;
      var t = tierOf(el);
      if (t.subtext) { out.textContent = t.subtext; return; }
      var totals = tierTotals(t, u);
      out.textContent = totals.save > 0 ? 'Save ' + formatMoneyShort(totals.save) : '';
    });
  }

  function variantOption(v, pos) {
    if (!pos || isNaN(pos)) return null;
    if (v.options && v.options.length >= pos) return v.options[pos - 1];
    return v['option' + pos];
  }

  /* ---------- Variant resolution ----------
     Liquid's product.variants is capped at 250, so the embedded JSON only
     seeds the current product's cache. Any other size/colour combination is
     resolved through the Section Rendering API (?option_values=<id,id>) which
     re-renders the section with product.selected_variant set, and cached from
     then on. Caches are kept per product because the pack builder can mix
     designs — each mixable design resolves against its own product URL.
       cache value: variant object = resolved, null = combination doesn't
       exist, key absent = not looked up yet. */
  var productCtx = {};

  function ctxFor(handle, url, sizeP, colorP) {
    var key = handle || '';
    if (!productCtx[key]) {
      productCtx[key] = { url: url, sizePos: sizeP, colorPos: colorP, cache: {}, pending: {} };
    }
    return productCtx[key];
  }

  var currentCtx = ctxFor(productHandle, productUrl, sizePos, colorPos);

  function comboKey(size, color) { return (size || '') + '\n' + (color || ''); }

  variants.forEach(function (v) {
    var s = isNaN(sizePos) ? null : variantOption(v, sizePos);
    var c = isNaN(colorPos) ? null : variantOption(v, colorPos);
    currentCtx.cache[comboKey(s, c)] = v;
  });

  // variant | null (known missing) | undefined (needs a lookup)
  function cachedVariantFor(ctx, size, color) {
    var key = comboKey(size, color);
    return key in ctx.cache ? ctx.cache[key] : undefined;
  }
  function cachedVariant(size, color) { return cachedVariantFor(currentCtx, size, color); }

  function valueIdFor(scope, pos, value) {
    if (!pos || isNaN(pos) || !value || !scope) return null;
    var esc = String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    var el = scope.querySelector('[data-option-position="' + pos + '"][data-value="' + esc + '"][data-value-id]');
    return el ? el.getAttribute('data-value-id') : null;
  }

  function resolveVariantFor(ctx, size, color, scope) {
    var key = comboKey(size, color);
    if (key in ctx.cache) return Promise.resolve(ctx.cache[key]);
    if (ctx.pending[key]) return ctx.pending[key];

    var ids = [];
    if (!isNaN(ctx.sizePos)) ids.push(valueIdFor(scope, ctx.sizePos, size));
    if (!isNaN(ctx.colorPos)) ids.push(valueIdFor(scope, ctx.colorPos, color));
    ids = ids.filter(Boolean);
    if (!ids.length || !sectionId || !ctx.url) {
      ctx.cache[key] = null;
      return Promise.resolve(null);
    }

    var url = ctx.url + '?section_id=' + encodeURIComponent(sectionId) + '&option_values=' + ids.join(',');
    ctx.pending[key] = fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.getElementById('pdResolvedVariant');
        var v = null;
        if (el) { try { v = JSON.parse(el.textContent); } catch (e) { v = null; } }
        delete ctx.pending[key];
        ctx.cache[key] = v || null;
        return ctx.cache[key];
      })
      .catch(function () {
        // Network error: leave the combo unresolved so it can be retried.
        delete ctx.pending[key];
        return undefined;
      });
    return ctx.pending[key];
  }

  function resolveVariant(size, color) {
    return resolveVariantFor(currentCtx, size, color, form);
  }

  /* ---------- Pack builder (mix & match) ----------
     When the selected tier allows mixing, the shopper picks the colour/size of
     every item in the pack. Each item becomes its own cart line, so variants
     and stock stay correct — a single line can only ever hold one variant. */
  var builder = document.getElementById('pdPackBuilder');
  var slotsEl = document.getElementById('pdPackSlots');
  var slotTpl = document.getElementById('pdSlotTemplate');
  var builderCount = document.getElementById('pdPackBuilderCount');
  var packError = document.getElementById('pdPackError');
  var fillBtn = document.getElementById('pdPackFill');
  var designLibrary = document.getElementById('pdDesignLibrary');
  var slotLabel = builder ? builder.getAttribute('data-slot-label') || '' : '';
  var mixMode = false;

  var propName = '';
  if (packProp) {
    var nameMatch = (packProp.getAttribute('name') || '').match(/^properties\[(.+)\]$/);
    propName = nameMatch ? nameMatch[1] : '';
  }

  function slotList() {
    return slotsEl ? Array.prototype.slice.call(slotsEl.querySelectorAll('.pack-slot')) : [];
  }

  function markActive(root, sel, value, cls) {
    root.querySelectorAll(sel).forEach(function (el) {
      el.classList.toggle(cls, el.getAttribute('data-value') === value);
    });
  }

  /* A slot can hold any mixable design. Each design's colour/size pickers are
     a pre-rendered .pack-slot__opts group; only the chosen design's group is
     visible, and it carries that product's url/positions for resolution. */
  function activeOpts(slot) {
    return slot.querySelector('.pack-slot__opts:not([hidden])');
  }

  function slotCtx(slot) {
    var g = activeOpts(slot);
    if (!g) return currentCtx;
    return ctxFor(
      g.getAttribute('data-handle') || productHandle,
      g.getAttribute('data-product-url'),
      parseInt(g.getAttribute('data-size-position'), 10),
      parseInt(g.getAttribute('data-color-position'), 10)
    );
  }

  function slotState(slot) {
    var g = activeOpts(slot);
    var color = g ? g.querySelector('.pack-slot__colors .sw--active') : null;
    var size = g ? g.querySelector('.pack-slot__sizes .size-box.active') : null;
    return {
      handle: g ? g.getAttribute('data-handle') : productHandle,
      title: g ? g.getAttribute('data-title') || '' : '',
      needSize: !!(g ? g.hasAttribute('data-size-position') : !isNaN(sizePos)),
      needColor: !!(g ? g.hasAttribute('data-color-position') : !isNaN(colorPos)),
      color: color ? color.getAttribute('data-value') : null,
      size: size ? size.getAttribute('data-value') : null
    };
  }

  function slotVariant(slot) {
    var s = slotState(slot);
    if (!isComplete(s)) return null;
    return cachedVariantFor(slotCtx(slot), s.size, s.color) || null;
  }

  // Kick off a lookup for a slot's combination if it isn't cached yet.
  function ensureSlotResolved(slot) {
    var s = slotState(slot);
    if (!isComplete(s)) return;
    var ctx = slotCtx(slot);
    if (cachedVariantFor(ctx, s.size, s.color) !== undefined) return;
    resolveVariantFor(ctx, s.size, s.color, activeOpts(slot)).then(function () {
      renderSlotStatus(slot);
      renderPrice(currentVariant);
      refreshCta();
    });
  }

  function renderSlotStatus(slot) {
    var out = slot.querySelector('.pack-slot__status');
    var s = slotState(slot);
    var parts = [];
    if (s.handle !== productHandle && s.title) parts.push(s.title);
    if (s.color) parts.push(s.color);
    if (s.size) parts.push(s.size);
    var chosen = parts.join(' · ');
    var bad = false;
    var text;

    if (!isComplete(s)) {
      text = chosen || 'Choose';
    } else {
      var v = cachedVariantFor(slotCtx(slot), s.size, s.color);
      if (v === undefined) {
        text = 'Checking…';
      } else if (!v) {
        bad = true;
        text = 'Unavailable';
      } else if (!v.available) {
        bad = true;
        text = 'Sold out';
      } else {
        text = chosen;
      }
    }

    slot.classList.toggle('pack-slot--invalid', bad);
    if (out) out.textContent = text;
  }

  function isComplete(s) {
    if (s.needSize && !s.size) return false;
    if (s.needColor && !s.color) return false;
    return true;
  }

  function applyToSlot(slot, color, size) {
    var g = activeOpts(slot);
    if (!g) return;
    if (color) markActive(g, '.pack-slot__colors .sw', color, 'sw--active');
    if (size) markActive(g, '.pack-slot__sizes .size-box', size, 'active');
    renderSlotStatus(slot);
    ensureSlotResolved(slot);
  }

  function optsGroup(root, handle) {
    if (!root || !handle) return null;
    var groups = root.querySelectorAll('.pack-slot__opts');
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].getAttribute('data-handle') === handle) return groups[i];
    }
    return null;
  }

  /* A slot starts with only the viewed product's pickers. Any other design's
     group is cloned out of #pdDesignLibrary the first time that slot uses it —
     the library holds one copy per design instead of one per design per slot.
     Once cloned it stays, so choices survive switching designs back and forth. */
  function ensureSlotGroup(slot, handle) {
    var g = optsGroup(slot, handle);
    if (g) return g;
    var src = optsGroup(designLibrary, handle);
    if (!src) return null;
    g = src.cloneNode(true);
    g.hidden = true;
    (slot.querySelector('.pack-slot__body') || slot).appendChild(g);
    return g;
  }

  // Switch a slot to another design: swap which options group is visible.
  // Selections made inside each group persist while switching back and forth.
  function selectDesign(slot, handle) {
    ensureSlotGroup(slot, handle);
    slot.querySelectorAll('.design-pick').forEach(function (b) {
      b.classList.toggle('design-pick--active', b.getAttribute('data-handle') === handle);
    });
    slot.querySelectorAll('.pack-slot__opts').forEach(function (g) {
      g.hidden = g.getAttribute('data-handle') !== handle;
    });
    renderSlotStatus(slot);
    ensureSlotResolved(slot);
  }

  function buildSlots(count) {
    if (!slotsEl || !slotTpl || !slotTpl.content) return;
    slotsEl.innerHTML = '';
    for (var i = 1; i <= count; i++) {
      var node = slotTpl.content.firstElementChild.cloneNode(true);
      node.setAttribute('data-slot', i);
      var num = node.querySelector('.pack-slot__num');
      if (num) num.textContent = (slotLabel ? slotLabel + ' ' : '') + i;
      slotsEl.appendChild(node);
      applyToSlot(node, selected.color, selected.size);
    }
  }

  // Slots the shopper hasn't customised follow the main Size / Colour pickers.
  function syncUntouchedSlots() {
    slotList().forEach(function (slot) {
      if (slot.getAttribute('data-touched') === 'true') return;
      applyToSlot(slot, selected.color, selected.size);
    });
  }

  // Every slot resolved to an available variant, or null.
  function packSelection() {
    if (!mixMode) return null;
    var slots = slotList();
    if (!slots.length) return null;
    var out = [];
    for (var i = 0; i < slots.length; i++) {
      var v = slotVariant(slots[i]);
      if (!v || !v.available) return null;
      out.push(v);
    }
    return out;
  }

  if (slotsEl) {
    slotsEl.addEventListener('click', function (e) {
      var pick = e.target.closest && e.target.closest('.design-pick');
      var sw = e.target.closest && e.target.closest('.pack-slot__colors .sw');
      var box = e.target.closest && e.target.closest('.pack-slot__sizes .size-box');
      if (!pick && !sw && !box) return;
      var slot = e.target.closest('.pack-slot');
      if (!slot) return;

      slot.setAttribute('data-touched', 'true');
      if (pick) {
        selectDesign(slot, pick.getAttribute('data-handle'));
      } else {
        var g = activeOpts(slot);
        if (sw && g) markActive(g, '.pack-slot__colors .sw', sw.getAttribute('data-value'), 'sw--active');
        if (box && g) markActive(g, '.pack-slot__sizes .size-box', box.getAttribute('data-value'), 'active');
        renderSlotStatus(slot);
        ensureSlotResolved(slot);
      }
      clearPackError();
      renderPrice(currentVariant);
      refreshCta();
    });
  }

  if (fillBtn) {
    fillBtn.addEventListener('click', function () {
      var slots = slotList();
      if (!slots.length) return;
      var first = slotState(slots[0]);
      slots.forEach(function (slot, i) {
        if (i === 0) return;
        slot.setAttribute('data-touched', 'true');
        if (slot.querySelector('.design-pick')) selectDesign(slot, first.handle);
        applyToSlot(slot, first.color, first.size);
      });
      clearPackError();
      renderPrice(currentVariant);
      refreshCta();
    });
  }

  function showPackError(msg) {
    if (!packError) return;
    packError.textContent = msg;
    packError.hidden = false;
  }
  function clearPackError() {
    if (packError) packError.hidden = true;
  }

  /* ---------- Price ----------
     Pack total, not unit price. With a mixed pack the total is summed from the
     actual chosen variants so differently-priced colours stay accurate. */
  function renderPrice(v) {
    if (!priceBox) return;
    var t = tierOf(activePack);
    var picks = packSelection();
    var totals;

    if (picks) {
      var sumPrice = 0;
      var sumFull = 0;
      picks.forEach(function (pv) {
        var u = unitPrices(pv);
        sumPrice += u.price;
        sumFull += u.full;
      });
      var now = Math.floor(sumPrice * (100 - t.discount) / 100);
      totals = { now: now, full: sumFull, item: Math.floor(now / picks.length) };
    } else {
      if (!v) return;
      totals = tierTotals(t, unitPrices(v));
    }

    var html = '';
    if (totals.full > totals.now) {
      html += '<span class="pd-price__old">' + formatMoney(totals.full) + '</span>';
    }
    html += '<span class="pd-price__now">' + formatMoney(totals.now) + '</span>';
    html += '<span class="pd-price__item">' + formatMoney(totals.item) + '/item</span>';
    priceBox.innerHTML = html;
  }

  /* ---------- Add-to-cart button state ---------- */
  function refreshCta() {
    if (!addBtn) return;

    if (mixMode) {
      var slots = slotList();
      if (!slots.length) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      var states = slots.map(slotState);
      if (states.some(function (s) { return !isComplete(s); })) {
        addBtn.disabled = false;
        addBtn.textContent = 'Complete Your Pack';
        return;
      }
      var lookups = slots.map(function (slot, i) {
        return cachedVariantFor(slotCtx(slot), states[i].size, states[i].color);
      });
      if (lookups.some(function (v) { return v === undefined; })) {
        addBtn.disabled = true;
        addBtn.textContent = 'Checking…';
        return;
      }
      if (lookups.some(function (v) { return !v || !v.available; })) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        return;
      }
      addBtn.disabled = false;
      addBtn.textContent = 'Add To Cart';
      return;
    }

    if (!isNaN(sizePos) && !selected.size) {
      addBtn.disabled = false;
      addBtn.textContent = 'Select A Size';
      return;
    }
    var v = cachedVariant(selected.size, selected.color);
    if (v === undefined) { addBtn.disabled = true; addBtn.textContent = 'Checking…'; return; }
    if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
    if (!v.available) { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; return; }
    addBtn.disabled = false;
    addBtn.textContent = 'Add To Cart';
  }

  function applyVariant(v) {
    currentVariant = v;
    if (idInput) idInput.value = v.id;
    renderPacks(v);
    renderPrice(v);
    refreshCta();
  }

  function update() {
    var hasSize = !isNaN(sizePos);
    if (hasSize && !selected.size) {
      renderPrice(currentVariant);
      refreshCta();
      return;
    }
    var v = cachedVariant(selected.size, selected.color);
    if (v) { applyVariant(v); return; }
    if (v === null) { renderPrice(currentVariant); refreshCta(); return; }

    // Not cached yet — resolve, then re-check that the selection didn't move on.
    refreshCta();
    var size = selected.size, color = selected.color;
    resolveVariant(size, color).then(function (rv) {
      if (selected.size !== size || selected.color !== color) return;
      if (rv) { applyVariant(rv); return; }
      renderPrice(currentVariant);
      refreshCta();
    });
  }

  document.querySelectorAll('.size-row .size-box').forEach(function (box) {
    box.addEventListener('click', function () {
      document.querySelectorAll('.size-row .size-box').forEach(function (b) { b.classList.remove('active'); });
      box.classList.add('active');
      selected.size = box.getAttribute('data-value');
      syncUntouchedSlots();
      update();
    });
  });

  document.querySelectorAll('.pd-swatches .sw').forEach(function (sw) {
    if (sw.classList.contains('sw--more')) return;
    sw.addEventListener('click', function () {
      document.querySelectorAll('.pd-swatches .sw').forEach(function (s) { s.classList.remove('sw--active'); });
      sw.classList.add('sw--active');
      selected.color = sw.getAttribute('data-value');
      if (colorLabel && selected.color) colorLabel.textContent = selected.color;
      syncUntouchedSlots();
      update();
    });
  });

  /* ---------- Selecting a bundle tier ---------- */
  function cartTarget() {
    var t = tierOf(activePack);
    var cart = window.__cartUrl || '/cart';
    return t.code ? '/discount/' + encodeURIComponent(t.code) + '?redirect=' + cart : cart;
  }

  function selectPack(pack) {
    if (!packRow || !pack) return;
    packRow.querySelectorAll('.pack').forEach(function (p) { p.classList.remove('pack--active'); });
    pack.classList.add('pack--active');
    activePack = pack;

    var t = tierOf(pack);
    if (qtyInput) qtyInput.value = t.qty;
    if (qtyLabel) qtyLabel.textContent = t.qty;

    if (packProp) {
      packProp.value = t.label;
      packProp.disabled = !t.label;
    }

    // Per-tier discount code is applied on the redirect to the cart.
    if (returnTo) {
      if (t.code) {
        returnTo.value = cartTarget();
        returnTo.disabled = false;
      } else {
        returnTo.value = '';
        returnTo.disabled = true;
      }
    }

    mixMode = pack.getAttribute('data-mix') === 'true';
    clearPackError();
    if (builder) {
      builder.hidden = !mixMode;
      if (mixMode) {
        if (builderCount) builderCount.textContent = ' ' + t.qty;
        buildSlots(t.qty);
      } else if (slotsEl) {
        slotsEl.innerHTML = '';
      }
    }

    renderPrice(currentVariant);
    refreshCta();
  }

  if (packRow) {
    packRow.querySelectorAll('.pack').forEach(function (pack) {
      pack.addEventListener('click', function () { selectPack(pack); });
    });
  }

  /* ---------- Accordions handled globally in global.js ---------- */

  /* ---------- Add to cart ---------- */
  function submitPack() {
    var slots = slotList();

    var previous = addBtn ? addBtn.textContent : '';
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }

    // Make sure every slot's combination is resolved before validating.
    Promise.all(slots.map(function (slot) {
      var s = slotState(slot);
      if (!isComplete(s)) return Promise.resolve(null);
      return resolveVariantFor(slotCtx(slot), s.size, s.color, activeOpts(slot));
    })).then(function (resolved) {
      var firstBad = null;
      slots.forEach(function (slot, i) {
        renderSlotStatus(slot);
        var v = resolved[i];
        if ((!v || !v.available) && !firstBad) firstBad = slot;
      });

      if (firstBad) {
        if (addBtn) addBtn.textContent = previous;
        firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
        refreshCta();
        return;
      }

      var props = null;
      if (propName && packProp && packProp.value) {
        props = {};
        props[propName] = packProp.value;
      }

      var items = resolved.map(function (v) {
        var item = { id: v.id, quantity: 1 };
        if (props) item.properties = props;
        return item;
      });

      postPack(items, previous);
    });
  }

  function postPack(items, previous) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'Could not add this pack to the cart.');
        window.location.href = cartTarget();
      })
      .catch(function (err) {
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = previous; }
        showPackError(err.message);
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      if (mixMode) {
        e.preventDefault();
        submitPack();
        return;
      }
      if (!isNaN(sizePos) && !selected.size) {
        e.preventDefault();
        var row = document.querySelector('.size-row');
        if (row) row.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (addBtn) addBtn.textContent = 'Select A Size';
        return;
      }
      // Never submit while the combination is unresolved or known-missing.
      if (!cachedVariant(selected.size, selected.color)) e.preventDefault();
    });
  }

  if (activePack) selectPack(activePack);
  update();
})();